import ExpandCircleRight from './static/expand-circle-right';
import ExpandCircleLeft from './static/expand-circle-left';
import SaveToProjects from './static/save-to-projects';
import suggestedProducts from './static/suggested-products';
import CloseIcon from './static/close-icon';
import DownArrow from './static/down-arrow';
import MenuIcon from './static/menu-icon';
import ArrowLeft from './static/arrow-left';
import ImageModalCloseIcon from './static/pdp-close-icon';
import ChevronDropdownIcon from './static/chevron-dropdown-icon';
import PauseIcon from './static/pause-icon';
import PlayIcon from './static/play-icon';
import PLPWishlistEmptyHeart from './static/plp-wishlist-empty-heart';
import PLPWishlistHeart from './static/plp-wishlist-heart';
import FavouriteIcon from './static/favourite';
import FilledFavouriteIcon from './static/filled-favourite';
import ShareIcon from './static/share';
import RightArrowIcon from './static/right-arrow';
import CloseSearchIcon from './static/close-search';
import ChangeStoreIcon from './static/change-store';
import LocationIcon from './static/location';
import TimeIcon from './static/time';
import MapIcon from './static/map';
import NavLeftIcon from './static/arrow-nav-left';
import HorizontalMore from './static/horizon-more';
import FilterIconLightMobile from './static/filter-mob';
import CheckCircleIcon from './static/check-circle';
import StepperCheckmark from './static/stepper-checkmark';
import StepperCircle from './static/stepper-circle';
import StepperCircleOutline from './static/stepper-circle-outline';
import GPayIcon from './static/gPay-icon';
import StoreIcon from './static/store-icon';
import TruckIcon from './static/truck-icon';
import CartConfirmationTickIcon from './static/cart-confirmation-tick';
import UpArrowBlue from './static/up-arrow-blue';
import DownArrowBlue from './static/down-arrow-blue';
import AccordionUpArrow from './static/accordion-up-icon';
import AccordionDownArrow from './static/accordion-down-icon';
import SecureCheckout from './static/secure-checkout-icon';
import CheckIcon from  './static/check-icon';
import ChipCloseIcon from './static/chip-close-icon';
import TooltipIcon from './static/icon-tooptilp';
import DollarIcon from './static/payment-icon';
import UserIcon from './static/user-icon';
import VerifiedUserIcon from './static/verified-user-icon';
import OrderTruckIcon from './static/order-truck-icon';
import UserLocationIcon from './static/user-location-icon';
import UserEstimationTimeIcon from './static/order-estimation-time-icon';
import UserLocationLightIcon from './static/order-location-light-icon';
import UserDistanceIcon from './static/order-distance-icon';
import AddIcon from './static/add-icon';
import EditIcon from './static/edit-icon';
import DeleteIcon from './static/delete-icon';
import WarningIcon from './static/warning-icon';

import DocumentIcon from './static/document-icon';
import RightIcon from './static/right-caret-icon';
import BackIcon from './static/back-navigation';
import NextCategoryIcon from './static/next-category-right-caret';
import ChatIcon from './static/chat-icon';
import EmailIcon from './static/email-icon';
import HelpIcon from './static/help-icon';
import ChatBlackIcon from './static/chat-black-icon';
import ChatTootipIcon from './static/chat-tooltip-icon';
import ClockGrayIcon from './static/clock-gray-icon';
import ClockBlackIcon from './static/chat-tooltip-icon';
import ChangeStoreIconGray from './static/change-store-gray';
import GiftIcon from './static/gift';

const iconRegistry = {
  expandCircleRight: ExpandCircleRight,
  expandCircleLeft: ExpandCircleLeft,
  saveToProjects: SaveToProjects,
  suggestedProducts,
  close: CloseIcon,
  downArrow: DownArrow,
  menu: MenuIcon,
  arrowLeft: ArrowLeft,
  imageModalClose: ImageModalCloseIcon,
  chevronDropdown: ChevronDropdownIcon,
  pause: PauseIcon,
  play: PlayIcon,
  plpWishlistEmptyHeart: PLPWishlistEmptyHeart,
  plpWishlistHeart: PLPWishlistHeart,
  favourite: FavouriteIcon,
  filledFavourite: FilledFavouriteIcon,
  share: ShareIcon,
  rightArrow: RightArrowIcon,
  closeSearch: CloseSearchIcon,
  changeStore: ChangeStoreIcon,
  location: LocationIcon,
  time: TimeIcon,
  map: MapIcon,
  navLeft: NavLeftIcon,
  horizontalMore: HorizontalMore,
  filterLightMobile: FilterIconLightMobile,
  checkCircle: CheckCircleIcon,
  stepperCheckmark: StepperCheckmark,
  stepperCircle: StepperCircle,
  stepperCircleOutline: StepperCircleOutline,
  gPay: GPayIcon,
  store: StoreIcon,
  truck: TruckIcon,
  cartConfirmationTick: CartConfirmationTickIcon,
  upArrowBlue: UpArrowBlue,
  downArrowBlue: DownArrowBlue,
  accordionUpArrow: AccordionUpArrow,
  accordionDownArrow: AccordionDownArrow,
  secureCheckoutfrom: SecureCheckout,
  checkfrom: CheckIcon,
  chipClosefrom: ChipCloseIcon,
  tooltip: TooltipIcon,
  dollarfrom: DollarIcon,
  userfrom: UserIcon,
  verifiedUserfrom: VerifiedUserIcon,
  orderTruckfrom: OrderTruckIcon,
  userLocationfrom: UserLocationIcon,
  userEstimationTimefrom: UserEstimationTimeIcon,
  userLocationLightfrom: UserLocationLightIcon,
  userDistancefrom: UserDistanceIcon,
  addfrom: AddIcon,
  editfrom: EditIcon,
  deletefrom: DeleteIcon,
  warning: WarningIcon,
  document: DocumentIcon,
  right: RightIcon,
  back: BackIcon,
  nextCategory: NextCategoryIcon,
  chat: ChatIcon,
  email: EmailIcon,
  help: HelpIcon,
  chatBlack: ChatBlackIcon,
  chatTootip: ChatTootipIcon,
  clockGray: ClockGrayIcon,
  clockBlack: ClockBlackIcon,
  changeStoreGray: ChangeStoreIconGray,
  gift: GiftIcon,
}

type IconName = keyof typeof iconRegistry;

export function isValidIconName(value: string): value is IconName {
  return Object.prototype.hasOwnProperty.call(iconRegistry, value);
}

export function getIcon(value: unknown) {
  if (value == null) {
    return undefined;
  }

  if (typeof value !== 'string') {
    console.warn('Invalid icon configuration: expected a string icon name.', value);
    return undefined;
  }

  const normalizedName = value.trim().toLowerCase();
  if (normalizedName === '' || normalizedName === 'none') {
    return undefined;
  }

  const iconName = Object.keys(iconRegistry).find((key) => key.toLowerCase() === normalizedName);
  if (!iconName || !isValidIconName(iconName)) {
    console.warn('Unknown icon name:', normalizedName);
    return undefined;
  }

  return iconRegistry[iconName];
}

export {
  ExpandCircleRight,
  ExpandCircleLeft,
  SaveToProjects,
  suggestedProducts,
  CloseIcon,
  DownArrow,
  MenuIcon,
  ArrowLeft,
  ImageModalCloseIcon,
  ChevronDropdownIcon,
  PauseIcon,
  PlayIcon,
  PLPWishlistEmptyHeart,
  PLPWishlistHeart,
  FavouriteIcon,
  FilledFavouriteIcon,
  ShareIcon,
  RightArrowIcon,
  CloseSearchIcon,
  ChangeStoreIcon,
  LocationIcon,
  TimeIcon,
  MapIcon,
  NavLeftIcon,
  HorizontalMore,
  FilterIconLightMobile,
  CheckCircleIcon,
  StepperCheckmark,
  StepperCircle,
  StepperCircleOutline,
  GPayIcon,
  StoreIcon,
  TruckIcon,
  CartConfirmationTickIcon,
  UpArrowBlue,
  DownArrowBlue,
  AccordionUpArrow,
  AccordionDownArrow,
  SecureCheckout,
  CheckIcon,
  ChipCloseIcon,
  TooltipIcon,
  DollarIcon,
  UserIcon,
  VerifiedUserIcon,
  OrderTruckIcon,
  UserLocationIcon,
  UserEstimationTimeIcon,
  UserLocationLightIcon,
  UserDistanceIcon,
  AddIcon,
  EditIcon,
  DeleteIcon,
  WarningIcon,
  DocumentIcon,
  RightIcon,
  BackIcon,
  NextCategoryIcon,
  ChatIcon,
  EmailIcon,
  HelpIcon,
  ChatBlackIcon,
  ChatTootipIcon,
  ClockGrayIcon,
  ClockBlackIcon,
  ChangeStoreIconGray,
  GiftIcon,
}
